import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'common-card-footer',
    templateUrl: './common-card-footer.component.html',
    styleUrls: ['./common-card-footer.component.scss']
})
export class CommonCardFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
